import { VALIDATION_STATES } from '../../../core/const/fields.js';
import IS_DATE_SUPPORTED from '../../../core/detections/date-supported.js';

export default {
  props: {
    fieldId: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    minDate: {
      type: String,
    },
    maxDate: {
      type: String,
    },
    label: {
      type: String,
      required: true,
    },
    errorMessage: {
      type: String,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    validationState: {
      type: String,
      default: VALIDATION_STATES.unprocessed,
    },
    value: {
      type: String,
    },
    onChange: {
      type: Function,
      required: true,
    },
    onInstantChange: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      isFocused: false,
      internalValue: this.value,
      supported: IS_DATE_SUPPORTED,
    };
  },
  computed: {
    hasContent() {
      if (this.internalValue) {
        return this.internalValue.length > 0;
      }
      return false;
    },
    labelMessage() {
      if (this.isError) {
        return this.errorMessage;
      }
      // hack:
      // we will suggest unsupported users to write yyyy-mm-dd directly
      // (other browsers translate input date value into that format).
      // Thus, we are swapping dd/mm/yyyy for yyyy-mm-dd in the label.
      // It's part of isDate condition responsibility to check the format.
      if (!this.isSupported) {
        return `${this.label}  (YYYY-MM-DD)`;
      }
      return this.label;
    },
    isActive() {
      return this.isFocused || this.hasContent;
    },
    isValid() {
      return this.validationState === VALIDATION_STATES.valid;
    },
    isError() {
      return this.validationState === VALIDATION_STATES.error;
    },
    isSupported() {
      return this.supported;
    },
  },
  methods: {
    onBlur() {
      this.isFocused = false;
      this.onChange(this.internalValue);
    },
  },
  update() {
    this.internalValue = this.value;
  },
};
